// extracted by mini-css-extract-plugin
module.exports = {"tableActions":"TaskManagement_tableActions__uF1ZR"};